import React from "react"
import PropTypes from "prop-types"
import { Link, useHistory } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"
import BranchFilter from "./BranchFilter"
import { useRole } from "hooks/useRole"

const Breadcrumb = props => {
  const history = useHistory()
  const { isSuperAdmin } = useRole()

  return (
    <Row>
      <Col xs="12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center gap-3">
            <h4 className="mb-0 font-size-18 d-flex align-items-center">
              <i
                className="fas fa-arrow-left me-3"
                style={{
                  cursor: "pointer",
                  padding: "8px",
                  borderRadius: "8px",
                  transition: "all 0.2s ease",
                  color: "#556ee6"
                }}
                onClick={() => history.goBack()}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "rgba(85, 110, 230, 0.1)"
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent"
                }}
              ></i>
              {props.breadcrumbItem}
            </h4>
            {isSuperAdmin() && props.isBranchFilter && (
              <div style={{ marginLeft: "16px" }}>
                <BranchFilter />
              </div>
            )}
          </div>

          <div className="page-title-right d-flex align-items-center">
            <ol className="breadcrumb m-0">
              <BreadcrumbItem>
                <Link to="#">{props.title}</Link>
              </BreadcrumbItem>
              <BreadcrumbItem active>
                <Link to="#">{props.breadcrumbItem}</Link>
              </BreadcrumbItem>
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  )
}

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string,
  isBranchFilter: PropTypes.bool,
}

export default Breadcrumb
